const apply = {
  Devops: "DevOps Engineer Intern",
  Accounting: "Accounting Intern",
  CS: "Customer Success Intern",
  QA: "Quality Assurance Engineer Intern",
  FE: "Front-End Developer Intern",
  BD: "Business Development Intern",
  PM: "Project Management Intern",
  AM: "Account Management Intern",
  BE: "Back-End Developer Intern",
  UI: "UI/UX Design  Intern",
  Marketing: "Marketing Intern",
};

const department = {
  BO: "Back Office",
  BS: "BackStage",
  SLG: "SurveyCake SLG",
  PLG: "SurveyCake PLG",
  TopManagement: "Top Management",
};

export const AVAILABLE_APPLY = [
  apply.BD,
  apply.Marketing,
  apply.Devops,
  // # 註解為 2025未開放職缺，需先確認是否有開放
  // apply.Accounting,
  // apply.CS,
  // apply.FE,
  // apply.PM,
  // apply.AM,
];

export const APPLY_DATA = [
  {
    title: apply.BD,
    link: "https://25sprout.teamdoor.io/s/gIcK5RQQ ",
    department: department.SLG,
  },
  {
    title: apply.Marketing,
    link: "https://25sprout.teamdoor.io/s/BAvDeEk3",
    department: department.PLG,
  },
  {
    title: apply.Devops,
    link: "https://25sprout.teamdoor.io/s/IQtmc3u3",
    department: department.TopManagement,
  },
  {
    title: apply.Accounting,
    link: "https://25sprout.teamdoor.io/s/PrMlG9D5 ",
    department: department.BO,
  },
  {
    title: apply.CS,
    link: "https://25sprout.teamdoor.io/s/u6AJM6jK",
    department: department.SurveyCake,
  },
  {
    title: apply.FE,
    link: "https://25sprout.teamdoor.io/s/4pwzHvUM",
    department: department.SurveyCake,
  },
  {
    title: apply.PM,
    link: "https://25sprout.teamdoor.io/s/1PIzyu1T",
    department: department.BS,
  },
  {
    title: apply.AM,
    link: "https://25sprout.teamdoor.io/s/B9tgXQLu",
    department: department.BS,
  }
];



// WEBPACK FOOTER //
// ./src/models/Apply.js